export const ANALYTICS_BASE_TAXONOMY = {
    country_code: 'gb',
    platform: 'React',
    brand_primary: 'zoopla',
    brand: 'zoopla'
};
